<template>
  <div class="request">
    <div class="box">
      <div class="box-text">{{ $t('main.PaperRequest') }}</div>
      <el-form :model="formData" :rules="rules" ref="formData" label-position="right" label-width="120px" class="">
        <el-form-item class="is-required" :label="$t('main.receiver')" prop="email">
          <el-input v-model="formData.name" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.email')" prop="email">
          <el-input v-model="formData.email" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.Country')" prop="country">
          <el-input v-model="formData.country" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.Company')" prop="company">
          <el-input v-model="formData.company" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.Address')" prop="address">
          <el-input v-model="formData.address" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" v-if="!isCN" :label="$t('main.ZipCode')" prop="zip_code">
          <el-input v-model="formData.zip_code" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.CompanyPhone')" prop="phone">
          <el-input v-model="formData.phone" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="loginBtn PaperRequestForGoogle" @click="request">{{ $t('main.commit') }}</el-button>
    </div>
  </div>
</template>

<script>
import { paperReq } from "@/api/index";
import Cookies from "js-cookie";
export default {
  components: {
  },
  data() {
    return {
      formData: {
        content_id: 0,
        site_id: 1,
        name: "",
        email: "",
        country: "",
        company: "",
        address: "",
        phone: "",
        zip_code: ""
      },
      rules: {
        name: [
          // { required: true, message: "请输入活动名称", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      },
      checked: false,//只有在cheked为true的时候才可以提交
      isCN: true, // 判断当前是中文还是英文
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.isCN = this.$i18n.locale === "zn";
    }
  },
  mounted() {
    this.userLanguage()
    //获取contentid
  },
  methods: {
    // 判断是否发送邮件
    userLanguage() {
      this.isCN = this.$i18n.locale === "zn";
    },
    goToLogin() {
      this.$router.push("/login");
    },
    request() {
      this.formData.content_id = this.$route.params.content_id;
      this.formData.site_id = Cookies.get("siteInfo");
      var paramsto = {
        "req":this.formData
      }
      paperReq(paramsto).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success'
          })
          this.$router.push("/service/catalog");
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
  }
};
</script>

<style scoped lang="less">
.request {
  text-align: center;

  .box {
    width: 40rem;
    margin: 3rem auto;

    .box-text {
      font-size: 1.285rem;
      font-weight: bold;
      color: #1a1a1a;
      padding-bottom: 3.75rem;
    }

    .leftcheck {
      margin: 1.875rem 0 3.75rem;
      text-align: left;
    }

    .loginBtn {
      width: 32.5rem;
      background: #635796;
      border-radius: 1rem;
      font-size: 1.1428rem;
      font-weight: 500;
      color: #ffffff;
    }

    .right {
      padding-top: 1.875rem;
      text-align: right;
    }

    /deep/ .el-form-item {
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      text-align: left;
    }

    /deep/ .el-form-item__label {
      font-size: 1rem;
    }

    /deep/ .el-input__inner {
      font-size: 1rem;
      border: 0px solid #dcdfe6;
    }
  }

  /deep/ .el-color-picker__icon, .el-input, .el-textarea{
    width: 80%;
  }

  /deep/ .el-form-item__label-wrap{
    margin-left: 12px;
  }

  /deep/ .el-form-item__label{
    padding: 0;
  }

  .required-text {
    color: red;
  }
}
</style>
